import { FC } from "react"
import { SafetiesEdit } from "../../../module/safeties/containers/edit"

export const SafetiesEditPage: FC = () => <SafetiesEdit />
